// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EAQGuOx9{align-items:flex-end;display:flex;gap:1rem;margin:1.5rem 0}.LIS9rPRi{flex:1}.LIS9rPRi .O0Qwfi8o .U6jeuePB::placeholder{font-style:normal}`, "",{"version":3,"sources":["webpack://./src/page-components/intent/AddForm.module.scss"],"names":[],"mappings":"AAAA,UACE,oBAAA,CACA,YAAA,CACA,QAAA,CACA,eAAA,CAGF,UACE,MAAA,CAKI,2CACE,iBAAA","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `EAQGuOx9`,
	"containerInputOutterWrapper": `LIS9rPRi`,
	"containerInputWrapper": `O0Qwfi8o`,
	"containerInput": `U6jeuePB`
};
export default ___CSS_LOADER_EXPORT___;
